import FormField from "components/v2/FormField";
import RichTextEditor from "components/RichTextEditor";
import { MAX_IMAGE_SIZE } from "utils";

export default function PhysicalBookFields({ values, errors, touched, setFieldValue, categoryOptions, genreOptions,
	isCategoriesLoading, isGenresLoading, showStock = false, currentCover }) {
	return <>
		<fieldset className="akello-form-section">
			<legend>Book details</legend>
			<p className="akello-form-section-hint">The information readers use to find this edition.</p>
			<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
				<FormField name="title" label="Book title *" placeholder="Title on the cover" />
				<FormField name="author" label="Author *" placeholder="Author’s full name" />
			</div>
			<FormField name="isbn" label="ISBN" placeholder="e.g. 9781234567890" />
			<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
				<FormField type="select" name="category_id" label="Category *" options={categoryOptions} isLoading={isCategoriesLoading} />
				<FormField type="select" name="genres" label={showStock ? "Genre *" : "Genre"} options={genreOptions} isLoading={isGenresLoading} />
			</div>
		</fieldset>
		<fieldset className="akello-form-section">
			<legend>{showStock ? "Pricing & inventory" : "Pricing"}</legend>
			<div className={`grid grid-cols-1 ${showStock ? "md:grid-cols-2" : ""} gap-4`}>
				<FormField type="number" name="physical_usd_price" label="Price (USD) *" placeholder="0.00" step="0.01" min="0" />
				{showStock && <FormField type="number" name="stock_level" label="Available copies *" placeholder="0" min="0" />}
			</div>
		</fieldset>
		<fieldset className="akello-form-section">
			<legend>Cover & summary</legend>
			<FormField type="file" name="book_cover" label={showStock ? "Book cover *" : "Book cover"}
				accept="image/jpeg,image/png,image/svg+xml,image/webp" maxSize={MAX_IMAGE_SIZE * 1024 * 1024}
				fileHint={`JPG, PNG, SVG or WebP · Up to ${MAX_IMAGE_SIZE} MB`} />
			{currentCover && !values.book_cover && <div className="akello-current-cover"><img src={currentCover} alt="Current book cover" /><p>Current cover<span>Choose a file above to replace it.</span></p></div>}
			<div className="space-y-2">
				<p className="akello-field-label">Book summary</p>
				<RichTextEditor label="Book summary" value={values.description} onTextChange={(event) => setFieldValue("description", event.htmlValue)} error={touched.description && errors.description} />
			</div>
		</fieldset>
	</>;
}
